import React from "react";
import { Dialog, DialogContent, IconButton, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ImagePopup = ({ open, onClose, imageUrl }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md">
            <DialogTitle>
                Image
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt="Preview"
                        style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "8px",
                            objectFit: "contain",
                        }}
                    />
                ) : (
                    <p>No image available</p>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ImagePopup;
